import type { SlideProps } from "@/engine/app/offsite-config";

export function Slide03Kette(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Ein Vorgang, keine Handgriffe</div>
        <h1 className="deck-title rise rise-2">
          So sieht das <br />
          <span className="accent">konkret aus</span>
        </h1>
        <p className="deck-sub rise rise-3">
          Vom Anruf bis zur Erledigung — ohne dass jemand etwas abtippt.
        </p>
      </header>

      <div className="ki-sort-flow">
        <div className="col-card rise rise-4 ki-sort-step">
          <div className="num">01</div>
          <h4>Kunde schickt sein Anliegen — per Formular, App oder E-Mail</h4>
        </div>

        <div className="ki-sort-quote rise rise-5">
          <div className="ki-sort-quote-from">Kunde schreibt:</div>
          <div className="ki-sort-quote-text">
            „Meine neue IBAN ist <strong>DE89 7894 5678 9012 3456 78</strong> —
            und mein Zählerstand ist <strong>4.521</strong>.“
          </div>
          <div className="ki-sort-quote-tags">
            <span className="ki-sort-tag">IBAN-Änderung</span>
            <span className="ki-sort-tag">Zählerstand</span>
          </div>
        </div>

        <div className="ki-sort-row">
          <div className="col-card rise rise-5 ki-sort-step">
            <div className="num">02</div>
            <h4>Make erkennt beides und legt die passenden Zendesk-Vorgänge an</h4>
          </div>
          <div className="col-card rise rise-6 ki-sort-step">
            <div className="num">03</div>
            <h4>Die kVASy-Webservices schreiben IBAN und Zählerstand direkt ins System — erledigt.</h4>
          </div>
        </div>
      </div>
    </div>
  );
}
